module.exports = __webpack_public_path__ + "img/icon_listmytools_coverage.9f31b0da.svg";